import { LineChart } from "../../components";
import PainCard from "../../components/pain-card/pain-card";

export const MrTable = ({ data }) => {
    // Extract unique period ranges from first MR (assuming all MR have same periods)
    const periods = data[0]?.mrCodeData.map((item) => {
        const start = new Date(item.period_start).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        });
        const end = new Date(item.period_end).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
        });
        return `${start} - ${end}`;
    });

    return (
        <div style={{ overflowX: "auto" }}>
            <table
                style={{
                    width: "100%",
                    borderCollapse: "collapse",
                    textAlign: "center",
                    background: "#fff",
                    border: "1px solid #ddd",
                }}
            >
                <thead style={{ backgroundColor: "#FFA500", color: "#fff" }}>
                    <tr>
                        <th style={styles.th}>Name</th>
                        <th style={styles.th}>Role</th>
                        {periods?.map((p, i) => (
                            <th key={i} style={styles.th}>
                                {p}
                            </th>
                        ))}
                        <th style={styles.th}>Total</th>
                    </tr>
                </thead>
                <tbody>
                    {data.map((mr, index) => {
                        const total = mr.mrCodeData.reduce(
                            (sum, item) => sum + item.usage_count,
                            0
                        );
                        return (
                            <tr key={index} style={index % 2 === 0 ? styles.rowEven : styles.rowOdd}>
                                <td style={styles.td}>{mr.mrName}</td>
                                <td style={styles.td}>MR</td>
                                {mr.mrCodeData.map((item, i) => (
                                    <td key={i} style={styles.td}>
                                        {item.usage_count}
                                    </td>
                                ))}
                                <td style={{ ...styles.td, fontWeight: "bold", color: "#FF6600" }}>
                                    {total}
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
};

const styles = {
    th: {
        border: "1px solid #ddd",
        padding: "8px",
    },
    td: {
        border: "1px solid #ddd",
        padding: "8px",
    },
    rowEven: {
        backgroundColor: "#fffaf0",
    },
    rowOdd: {
        backgroundColor: "#fff",
    },
};


export default function RM_UI({ data }) {
    return (
        <>
            <div className="cards">
                <div className="card">
                    <h2>29.4</h2>
                    <p className="title">Average Patient Registration (Monthly)</p>
                    <p className="target">Monthly Target: 31.5</p>
                    {/* Placeholder for chart */}
                    <div><LineChart data={data?.monthlyUsersCount} /></div>
                </div>

                <PainCard
                    title="Average Patient Registration (Pain Classified) (Monthly)"
                    pain1={data?.rmPainAvg?.pain1Avg}
                    pain2={data?.rmPainAvg?.pain2Avg}
                    overall={data?.rmPainAvg?.overAllPainAvg}
                    target={11.0}
                />
                <PainCard
                    title="Average Patient Registration (Pain Classified) (Monthly)"
                    pain1={data?.mrPainAvg?.pain1Avg}
                    pain2={data?.mrPainAvg?.pain2Avg}
                    overall={data?.mrPainAvg?.overAllPainAvg}
                    target={11.0}
                />
            </div>

            {/* ---------- PERFORMANCE TABLE ---------- */}
            <div className="table-container">
                <h3>Performance Data - Patient Registration</h3>
                <MrTable data={data?.results} />

            </div>
            <div style={{height:"200px"}}></div>

        </>
    );
}